import { render, staticRenderFns } from "./listhistory.vue?vue&type=template&id=57cceca0&"
import script from "./listhistory.vue?vue&type=script&lang=js&"
export * from "./listhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports